(function(){
  document.querySelectorAll('[data-gf-root]').forEach(function(root){
    var thumbs=root.querySelectorAll('[data-gf-thumb]');
    var slides=root.querySelectorAll('[data-gf-slide]');
    thumbs.forEach(function(t,i){
      t.addEventListener('click',function(){
        slides.forEach(function(s,j){s.hidden=(i!==j);});
        thumbs.forEach(function(x,j){x.setAttribute('aria-pressed',i===j?'true':'false');});
      });
    });
    var sel=root.querySelector('[data-gf-select]');
    var price=root.querySelector('[data-gf-price]');
    var cmp=root.querySelector('[data-gf-compare]');
    var btn=root.querySelector('[data-gf-btn]');
    if(sel){
      sel.addEventListener('change',function(){
        var o=sel.options[sel.selectedIndex];
        price.textContent=o.getAttribute('data-price');
        var c=o.getAttribute('data-compare');
        if(cmp){cmp.textContent=c||'';cmp.hidden=!c;}
        if(btn){
          var ok=o.getAttribute('data-available')==='true';
          btn.disabled=!ok;
          btn.textContent=ok?btn.getAttribute('data-add'):btn.getAttribute('data-sold');
        }
      });
    }
  });
})();